/**
 * Created by abdelhalim on 2017-07-14.
 */

import { vnAppZone } from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone";
import { pageFactory } from "../modules/factory";


export class vnAppZoneMenu extends vnAppZone {

    public constructor(destination) {
        super(destination);
        this.zoneName = "Menu";
        this.isOnAlwaysReloadMode = true;
    }

    defineRoutes() {


        let factory = new pageFactory();
        let _mythis = this;

        const isMobile = /Android|webOS|iPhone|IEMobile|Opera Mini/i.test(navigator.userAgent);

        if (isMobile) {
            //define routes
            this.addForRoute('all', function () {

                // obtain the right module object
                let moduleObj = factory.get_actionHandler("menu_pwa", _mythis);

                // load it into the zone
                _mythis.loadModule(moduleObj);
            }, null);

            this.addForRoute('/menu_pwa', function () { }, null);
        }
        else {
            //define routes
            this.addForRoute('all', function () {

                // obtain the right module object
                let moduleObj = factory.get_actionHandler("menu", _mythis);

                // load it into the zone
                _mythis.loadModule(moduleObj);
            }, null);

            this.addForRoute('/menu', function () { }, null);
        }
    }
}



// WEBPACK FOOTER //
// ./js/components/vn_app_zone_menu.ts